import { Injectable } from '@angular/core';

@Injectable()
export class DataSharingConfig {
  profilesBaseUrl: string = '';
  acceptedConsentTrn: string = '';
  rejectedConsentTrn: string = '';
}
